export default __webpack_public_path__ + "static/media/upload-outline-16px.a7122893.svg";